export default __webpack_public_path__ + "static/media/photobooth1.3f6c5894.png";